/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Animalfirstnameplaceholder4Inputs */

const en_newpatient_animalfirstnameplaceholder4 = /** @type {(inputs: Newpatient_Animalfirstnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Max, Luna, Charlie...`)
};

const fr_newpatient_animalfirstnameplaceholder4 = /** @type {(inputs: Newpatient_Animalfirstnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex: Max, Luna, Charlie...`)
};

/**
* | output |
* | --- |
* | "e.g., Max, Luna, Charlie..." |
*
* @param {Newpatient_Animalfirstnameplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_animalfirstnameplaceholder4 = /** @type {((inputs?: Newpatient_Animalfirstnameplaceholder4Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Animalfirstnameplaceholder4Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_animalfirstnameplaceholder4(inputs)
	return fr_newpatient_animalfirstnameplaceholder4(inputs)
});
export { newpatient_animalfirstnameplaceholder4 as "newPatient_animalFirstNamePlaceholder" }